(function () {
  if (document.documentElement.hasAttribute('data-dn-cart-upsell-ready')) {
    return;
  }

  document.documentElement.setAttribute('data-dn-cart-upsell-ready', '');

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dn-creatine-add]');

    if (!button || button.disabled) {
      return;
    }

    event.preventDefault();

    var status = button.closest('.dn-cart-upsell').querySelector('[data-dn-cart-upsell-status]');
    var originalLabel = button.textContent;
    var formData = new FormData();
    formData.append('id', button.getAttribute('data-variant-id'));
    formData.append('quantity', '1');

    button.disabled = true;
    button.classList.add('btn--loading');
    status.textContent = '';

    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status === 422) {
            throw new Error(data.description || 'Could not add creatine.');
          }

          return data;
        });
      })
      .then(function (product) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: button
          }
        }));
      })
      .catch(function (error) {
        status.textContent = error.message || 'Could not add creatine. Please try again.';
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('btn--loading');
        button.textContent = originalLabel;
      });
  });
})();
